export enum RideDocumentType {
    CONTRACT = 'CONTRACT',
    TRAVEL_ORDER = 'TRAVEL_ORDER',
    REPORT = 'REPORT',
}